
import React from 'react'
import { ChevronsRight, ChevronsLeft } from 'react-feather'
import { Box, HBox, VBox } from './Box'
import AccountMenuButton from './AccountMenuButton'
import Heading from './Heading'
import Button from './Button'

/**
 * Expose component.
 */

export default Page

/**
 * Page component.
 */

function Page({ children }) {
  return <HBox displayName="Page" borderTop flex>
    {children}
  </HBox>
}

/**
 * Expose components.
 */

Page.Logo = Logo
Page.Title = Title
Page.Sidebar = Sidebar
Page.Header = Header
Page.Content = Content
Page.Content.Wrapper = Wrapper

/**
 * Title component.
 */

function Title({ text, children }) {
  return <Header>
    <HBox displayName="Title" alignY="center" alignX="between" flex>
      {text ? <Heading size={2}>{text}</Heading> : <Box /> }
      {children}
    </HBox>
  </Header>
}

/**
 * Header component.
 */

function Header({ children }) {
  return <HBox
    displayName="Header"
    height="3.5rem"
    background={0}
    borderBottom
    shadowBottom
    flexShrink={0}
  >
    <HBox paddingX={6} flex>
      {children}
    </HBox>
  </HBox>
}

/**
 * Sidebar component.
 */

function Sidebar({ expanded, onClickExpand, children }) {
  function bottom() {
    if (expanded) {
      // TODO: shouldn't need flex-end here... "end" should be ok
      return <HBox paddingX={3} alignSelf="flex-end">
        {/* <AccountMenuButton expanded={expanded} user={user} /> */}
        <ExpandButton expanded={expanded} onClick={onClickExpand} />
      </HBox>
    }

    return <HBox>
      {/* <AccountMenuButton user={user} /> */}
      <ExpandButton expanded={expanded} onClick={onClickExpand} />
    </HBox>
  }

  return <VBox
    displayName="Sidebar"
    className={`Sidebar ${expanded && 'expanded'}`}
    width={expanded ? 225 : "3.5rem"}
    overflow="hidden"
    borderRight
    shadowRight
    background={0}
  >
    {children}
    <VBox
      marginTop="auto"
      alignX="center"
      alignY="center"
      height="3.5rem"
      borderTop
    >
      {bottom()}
    </VBox>
  </VBox>
}

/**
 * ExpandButton component.
 */

function ExpandButton({ expanded, ...props }) {
  const icon = expanded
    ? ChevronsLeft
    : ChevronsRight
  return <Button icon={icon} theme="minimal" {...props} />
}

/**
 * Content component.
 */

function Content({ children }) {
  return <VBox displayName="Content" overflowY="auto" flex>
    {children}
  </VBox>
}

/**
 * Wrapper component.
 */

function Wrapper({ children }) {
  return <VBox overflowY="auto" flex>
    <VBox
      margin="6rem auto"
      animate="show"
      width={750}
      background={0}
      borderRadius={2}
      padding={8}
      shadow={2}
      flexShrink={0}
    >
      {children}
    </VBox>
  </VBox>
}

/**
 * Logo component.
 */

function Logo() {
  return <HBox
    height="3.5rem"
    align="center"
    borderBottom
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" style={{ transform: 'scale(0.85)' }}>
      <g transform="translate(7.307 9.054)">
        <path
          d="M 0 13.658 L 6.011 0 L 7.774 0 L 13.726 13.658 L 11.737 13.658 L 6.926 2.356 L 6.907 2.4 L 6.834 2.218 L 4.229 8.623 L 4.258 8.623 L 2.115 13.658 Z"
          fill="currentColor"></path>
      </g>
    </svg>
  </HBox>
}

